import { TableSearch } from 'shared/ui/TableNew'
import styles from './styles.module.scss'

export const TextingHeader = ({
  search,
  setSearch,
}: {
  search: string
  setSearch: (value: string) => void
}) => {
  return (
    <header className={styles.header}>
      <TableSearch value={search} onChange={setSearch} />
    </header>
  )
}
